export default "__VITE_PUBLIC_ASSET__dea05f49__"